<template>
    <!-- Contenedor opcional de referencia -->
    <div id="sparkles-container"></div> 
</template>

<script>
export default {
  name: "CursorFlowers",
  mounted() {
    // Verificamos que no sea dispositivo móvil
    if (window.innerWidth > 768) {
      let lastMove = 0;

      this.handleMouseMove = (e) => {
        const now = Date.now();

        // Limita la cantidad para que no se sature el DOM (cada 50ms)
        if (now - lastMove < 50) return;
        lastMove = now;

        const sparkle = document.createElement("div");
        sparkle.className = "sparkle";

        // Ligera variación para que se vea natural
        const offsetX = (Math.random() - 0.5) * 15;
        const offsetY = (Math.random() - 0.5) * 15;

        sparkle.style.left = e.clientX + offsetX + "px";
        sparkle.style.top = e.clientY + offsetY + "px";

        document.body.appendChild(sparkle);

        // Se remueve exactamente cuando termina la animación CSS (1.5 segundos)
        setTimeout(() => {
          sparkle.remove();
        }, 1500);
      };

      document.addEventListener("mousemove", this.handleMouseMove);
    }
  },
  beforeUnmount() {
    // Limpiamos el evento cuando el componente se destruye para evitar fugas de memoria
    if (this.handleMouseMove) {
      document.removeEventListener("mousemove", this.handleMouseMove);
    }
  }
};
</script>

<style >
/* Estrellas / Flores en cursor */
.sparkle {
  position: fixed;
  width: 12px;
  height: 12px;
  pointer-events: none;
  z-index: 9999; /* Asegura que flote por encima de todo */
  animation: sparkleFade 1.5s linear forwards;
}

.sparkle::before {
  content: "🌸"; /* Usamos un emoji de flor nítido, o puedes cambiarlo por "✦" o "*" */
  color: #f879bf;
  font-size: 14px;
  position: absolute;
  transform: translate(-50%, -50%);
}

@keyframes sparkleFade {
  0% {
    opacity: 1;
    transform: scale(0.6) rotate(0deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.4) rotate(180deg);
  }
}

.dp-custom-cell {
  border-radius: 50%;
  color: black;
  font-size: 1.3rem; 
}

.fancy {
  position: relative;
  white-space: nowrap;
}

.fancy::after {
  --deco-height: 0.3125em;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(var(--deco-height) * -0.625);
  height: var(--deco-height);
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath d='M-17 30.5C-1 22 72-4 54 13 37.9 28.2-2.5 57.5 16 55.5s72-29 104-40' stroke='%2300FDCF' stroke-width='10'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h100v64H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  background-size: auto 100%;
  background-repeat: round;
  background-position: 0em;
}
</style>